import queryString from "query-string";
import Axios from "axios";

const _config = {
  baseURL: `${process.env.REACT_APP_SERVER_URL}`,
  withCredentials: true,
};

export const axios = Axios.create(_config);

axios.interceptors.response.use(
  (res) => res,
  (err) => err.response
);

export async function get(url, query, config) {
  const request = queryString.stringifyUrl({ url, query });

  const response = await axios.get(request, config);

  return response;
}
export async function put(url, body, config) {
  const response = await axios.put(url, body, config);

  return response;
}
export async function del(url, query, config) {
  const response = await axios.delete(url, query, config);

  return response;
}
export async function post(url, body, config) {
  const response = await axios.post(url, body, config);

  return response;
}

export async function patch(url, body, config) {
  const response = await axios.patch(url, body, config);

  return response;
}

export const fetcher = (url) =>
  axios.get(url).then((response) => response.data);
